import React from 'react';
import cx from 'classnames';
import CopyReferral from '../CopyReferral';
import Typography from '@material-ui/core/Typography';
import {Icon} from 'epic-diesel-common';
import {Product} from '../../../../../shared/types';
import useStyles from './BrowseListItem.styles';
import genShareableLink from '../../utils/getShareableLink';
import formatShareRate from '../../utils/formatShareRate';
import {BrowseListMessages} from './BrowseList';
import {DirectionAuto} from '../../../../components';
import isFortnite from '../../utils/isFortnite';

export interface GameCardProps {
    className?: string | typeof cx;
    item: Product;
    enableLink?: boolean;
    baseStoreUrl: string;
    accountId: string;
    messages: BrowseListMessages;
}

export const GameCard: React.FC<GameCardProps> = ({
    className,
    item,
    enableLink,
    baseStoreUrl,
    accountId,
    messages
}) => {
    const styles = useStyles();
    const {namespace, title, icon} = item || {};
    const shareableLink = genShareableLink(item, baseStoreUrl, accountId);
    const formattedShareRate = formatShareRate(item, messages);

    return (
        <div className={cx(styles.root, className)}>
            <div className={styles.cardContent}>
                <div className={styles.cardBannerWrapper}>
                    <div className={styles.cardBanner}>
                        {isFortnite(namespace) ? (
                            <Icon icon="FORTNITE" />
                        ) : icon ? (
                            <img src={icon} alt={title} />
                        ) : null}
                    </div>
                </div>
                <div className={styles.cardMeta}>
                    <div className={styles.cardText}>
                        <Typography aria-label={title}>
                            <DirectionAuto>{title}</DirectionAuto>
                        </Typography>
                        <Typography aria-label={formattedShareRate}>
                            <DirectionAuto>{formattedShareRate}</DirectionAuto>
                        </Typography>
                    </div>

                    <div className={styles.cardLink}>
                        <CopyReferral
                            link={shareableLink}
                            enableLink={enableLink}
                            copyReferralLink={messages.copyLink}
                            copyReferralLinkSuccess={messages.copyLinkSuccess}
                            copyReferralLinkFailed={messages.copyLinkFail}
                            trackEventProps={{
                                interactionType: 'Click',
                                eventCategory: 'MediaCreator',
                                eventAction: 'ClickBrowseGamesCopyReferralLink'
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GameCard;
